import gql from 'graphql-tag';

import { useQuery } from '@apollo/client';
import { Errors } from '../../Shared/Errors';
import { getUser } from './__generated__/getUser';

export const USER_QUERY = gql`
  query getUser {
    user {
      id
      firstName
      lastName
      email
      praiseDirectory {
        value
      }
      permissions {
        value
      }
      userType {
        id
      }
      departmentData {
        id
        name
      }
      locationData {
        id
        name
      }
      country {
        value
      }
      state {
        value
      }
      features
    }
  }
`;

const useUser = () => {
  const { data, loading, refetch } = useQuery<getUser>(USER_QUERY, {
    errorPolicy: 'all',
    returnPartialData: false,
    fetchPolicy: 'network-only',
  });

  if (data && loading) {
    return {
      loading: true,
    };
  }

  if (data?.user) {
    return {
      firstName: data.user.firstName || '',
      lastName: data.user.lastName || '',
      email: data.user.email || '',
      praiseDirectory:
        data.user.praiseDirectory !== null
          ? data.user.praiseDirectory.value === '1'
          : true,
      permissions: data.user.permissions?.value
        ? [data.user.permissions.value.toLowerCase()]
        : [],
      userType: data.user.userType.id || 1,
      locationId: data.user.locationData
        ? data.user.locationData.id
        : undefined,
      departmentId: data.user.departmentData
        ? data.user.departmentData.id
        : undefined,
      talkCountry: data.user.country?.value
        ? data.user.country.value
        : undefined,
      talkState: data.user.state ? data.user.state.value : undefined,
      features: data.user.features,
      loading: false,
      refetch,
    };
  }

  return {
    error: Errors.ServerError,
    loading: false,
  };
};

export default useUser;
